import { observable, transaction, makeObservable } from "mobx"
import { BaseStore } from "stores/base.store"
import { listAbExperiments, setAbExperiment, endAbExperiment, updateAbVariantsForceAccounts } from "../api/ab-testing.call"
import { AbExperiment, UpdateVariantForceAccountsData } from "./types"
import { RootStore } from "stores/root.store"

export class AbTestingStore extends BaseStore {
  @observable
  private _experiments: AbExperiment[] = []

  @observable
  public isLoading: boolean = false

  @observable
  public includeEnded: boolean = false

  constructor(rootStore: RootStore) {
    super(rootStore)
    makeObservable(this)
  }

  public async loadExperiments(): Promise<void> {
    this.resetFuncAfterSuccess()
    const res = await this.defaultFunction(listAbExperiments, undefined, this.includeEnded)
    if (Array.isArray(res)) {
      transaction(() => {
        this._experiments = res
      })
    }
  }

  public async setExperiment(data: Parameters<typeof setAbExperiment>[0]): Promise<AbExperiment> {
    this.resetFuncAfterSuccess()
    this.isLoading = true

    return setAbExperiment(data)
      .then(async res => {
        await this.loadExperiments()

        return res
      }).finally(() => {
        this.isLoading = false
      })
  }

  public async endExperiment(name: string): Promise<void> {
    this.resetFuncAfterSuccess()
    this.funcAfterSuccess = async() => {
      await this.loadExperiments()
    }
    await this.defaultFunction(endAbExperiment, name)
  }

  public async updateVariantsForceAccounts(
    experimentName: string,
    data: Record<string, UpdateVariantForceAccountsData>,
  ): Promise<void> {
    this.resetFuncAfterSuccess()
    this.funcAfterSuccess = async() => {
      await this.loadExperiments()
    }
    await this.defaultFunction(updateAbVariantsForceAccounts, experimentName, data)
  }

  public setIncludeEnded(value: boolean): void {
    transaction(() => {
      this.includeEnded = value
    })
    this.loadExperiments()
  }

  get experiments(): AbExperiment[] {
    return this._experiments
  }
}
